<template>
  <div class="card">
    <div class="card-content">
      <div class="card-content-title">
        <img v-bind:src="symbol" class="card-image" />
        <div class="card-content-name">
          <strong>{{ full_name }} ({{ name }})</strong>
        </div>
        <p class="card-content-rank">{{ rank }}</p>
      </div>
      <div>
        <p v-if="raw.USD" class="card-content-price">
          {{ roundDec(raw.USD.PRICE) }} USD
        </p>
        <p v-else class="card-content-price">No Data</p>
        <div class="card-stats">
          <span v-if="raw.USD" v-bind:style="getColor(raw.USD.CHANGEPCT24HOUR)">
            <template v-if="raw.USD.CHANGEPCT24HOUR > 0">+</template>
            {{ display.USD.CHANGE24HOUR }} ({{
              roundDec(raw.USD.CHANGEPCT24HOUR)
            }}%)
          </span>
          <span v-else>No Data</span>
          <div class="card-content-time">Last 24 hrs</div>
        </div>
      </div>

      {{ getCoinSparkline }}
      {{ getCoinbyID(name) }}
      <div class="card-sparkline" v-if="loadSparkline">
        <SparkLine :data="spark.price" />
      </div>
    </div>
  </div>
</template>

<script>
import SparkLine from '../components/SparkLine.vue'

export default {
  name: 'card',
  props: [
    'name',
    'full_name',
    'symbol',
    'rank',
    'price_usd',
    // 'price_sgd',
    // 'price_eur',
    // 'price_krw',
    // 'price_php',
    'percent_change_1h',
    'percent_change_24h',
    'percent_change_7d',
    'change_per_24h',
    'currency',
    'raw',
    'display',
  ],
  components: {
    SparkLine: SparkLine,
  },
  data: function() {
    return {
      sparkline: [],
      spark: {
        id: '',
        price: [0, 0],
      },
      loadSparkline: false,
      localData: [],
    }
  },
  methods: {
    getColor: (num) => {
      return num > 0
        ? 'color:hsl(141, 71%, 48%);'
        : 'color:hsl(348, 100%, 61%);'
    },
    roundDec: (amount) => {
      if (amount) {
        return Math.round(amount * 100) / 100
      }
    },
    getCoinbyID: function(id) {
      this.spark = this.localData.find((chart) => chart.id === id)
      this.loadSparkline = true
    },
    getAllCoins: function(charts) {
      let chartData = []

      if (charts.length > 0) {
        charts.forEach((chart) => {
          const filteredChart = {
            id: '',
            price: [],
          }

          filteredChart.id = chart.id

          chart.data.Data.Data.forEach((hour) => {
            filteredChart.price.push(hour.close)
          })
          chartData.push(filteredChart)
        })
        this.localData = chartData
      }
    },
  },
  computed: {
    getCoinSparkline: function() {
      let charts = this.$store.getters.charts
      this.getAllCoins(charts)
    },
  },
}
</script>

<style lang="scss">
.card,
.card-skeleton {
  // width: 250px;
  // height: auto;
  // width: calc(100% - (16px * 3));
  // height: 118px; //40px
  // margin: 0 auto;

  padding: 16px;
  border-radius: 4px;

  background: #ffffff;
  color: #b5b5b5;
  position: relative;
  box-shadow: 0 0 50px 5px rgba(201, 201, 201, 0.25);
  transition: all 0.2s ease-in-out;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 0 50px 10px rgba(201, 201, 201, 0.6);
    z-index: 2;
    cursor: pointer;
  }

  &-image {
    width: 20px;
    height: 20px;
  }

  &-stats {
    display: flex;
    align-items: center;

    p {
      margin: 0;
    }
  }

  &-sparkline {
    margin-top: 1rem;
  }

  &-content {
    text-transform: uppercase;
    font-size: 16px;
    color: #aabbc7; //#9A9E9E;
    position: relative;

    display: grid;

    @media (max-width: 480px) {
      font-size: 14px;
    }

    strong {
      color: rgb(117, 131, 138);
    }

    &-rank {
      // border-radius: 4px;
      font-size: 12px;
      margin-left: auto; // To force it to the right
    }

    &-title {
      font-size: 18px;
      display: flex;
      align-items: center;
    }

    &-price {
      padding: 0;
      margin: 0 0 8px 0;
      font-size: 24px;
      color: #000000;
    }

    &-divider {
      left: 20px;
      top: 10px;
      width: 1px;
      height: calc(100% - 20px);
      background: #ececec;
    }

    &-time {
      background: #b5b5b5;
      border-radius: 4px;
      color: white;
      padding: 4px;
      font-size: 12px;
      display: inline;
      margin-left: 8px;
    }

    &-name,
    &-price,
    &-divider {
      margin: 0;
    }

    &-name {
      margin-left: 4px;
    }
  }
}

.card-skeleton {
  .card-content {
    &-name {
      width: 100%;

      div {
        margin: 0;

        &:first-child {
          background: rgba(189, 189, 189, 0.5);
          height: 20px;
          width: 160px;
        }

        &:nth-child(2) {
          background: rgba(189, 189, 189, 0.5);
          height: 20px;
          width: 50px;
          margin-left: auto;
        }
      }
    }

    &-price {
      margin-top: 10px;
      background: rgba(189, 189, 189, 0.7);
      height: 30px;
      width: 160px;
    }

    &-stats {
      margin-top: 10px;

      .empty-time {
        background: rgba(189, 189, 189, 0.3);
        height: 20px;
        width: 80px;
        margin: 5px 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Card.vue